import * as ng from 'angular';
import { Compile } from './compile.directive';

export const CompileModule: string =
    ng.module('compile', [
    ])
        .directive('compile', Compile)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/compile/compile.module.ts